// extracted by mini-css-extract-plugin
export var black = "_k-6";
export var brand = "_k-1";
export var ddefault = "_k-0";
export var error = "_k-3";
export var gray = "_k-2";
export var highContrast = "_k-8";
export var outline = "_k-7";
export var success = "_k-5";
export var warning = "_k-4";